import type { StateCreator } from 'zustand'

import { type PrivateConsignedState, INITIAL_STATE } from './types'

const createPrivateConsignedSlice: StateCreator<
  PrivateConsignedState,
  [],
  [],
  PrivateConsignedState
> = (set) => ({
  privateConsigned: INITIAL_STATE,
  setPrivateConsignedObject: (privateConsigned) => set(() => ({ privateConsigned })),
  setPrivateConsignedCancellation: (cancellation) =>
    set((state) => ({
      privateConsigned: {
        ...state.privateConsigned,
        cancellation: {
          ...state.privateConsigned.cancellation,
          cancellation,
        },
      },
    })),
  setPrivateConsignedCancellationReasonCode: (cancellationReasonCode) =>
    set((state) => ({
      privateConsigned: {
        ...state.privateConsigned,
        cancellation: {
          ...state.privateConsigned.cancellation,
          reasonCode: cancellationReasonCode,
        },
      },
    })),
  setPrivateConsignedCancellationReasons: (cancellationReasons) =>
    set((state) => ({
      privateConsigned: {
        ...state.privateConsigned,
        cancellation: {
          ...state.privateConsigned.cancellation,
          reasons: cancellationReasons,
        },
      },
    })),
  setPrivateConsignedCancellationTerms: (isTermsAndConditionsAccepted) =>
    set((state) => ({
      privateConsigned: {
        ...state.privateConsigned,
        cancellation: {
          ...state.privateConsigned.cancellation,
          isTermsAndConditionsAccepted,
        },
      },
    })),
  setPrivateConsignedCancellationReceipt: (receipt) =>
    set((state) => ({
      privateConsigned: {
        ...state.privateConsigned,
        cancellation: { ...state.privateConsigned.cancellation, receipt },
      },
    })),
  resetPrivateConsigned: () => set(() => ({ privateConsigned: INITIAL_STATE })),
})

export default createPrivateConsignedSlice
